import { render } from "./B2bFilterButtonFacturasRecibidas.vue?vue&type=template&id=189737ec&scoped=true&lang=pug"
import script from "./B2bFilterButtonFacturasRecibidas.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonFacturasRecibidas.vue?vue&type=script&lang=js"

import "./B2bFilterButtonFacturasRecibidas.vue?vue&type=style&index=0&id=189737ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189737ec"]])

export default __exports__